import React from "react";
import "./language-modal.css";
import { Box, Modal } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  selectLabels,
  selectLanguage,
  setLanguage,
} from "../../../slices/language";

interface LanguageModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  currentLanguage: string;
  selectedLanguage: string;
  setSelectedLanguage: (selectedLanguage: string) => void;
  onChangeFunction: (value: string) => void;
}

const LanguageModal = ({
  show,
  setShow,
  selectedLanguage,
  setSelectedLanguage,
  currentLanguage,
  onChangeFunction,
}: LanguageModalProps) => {
  const labels = useAppSelector(selectLabels);

  const style = {
    position: "absolute" as "absolute",
    boxSizing: "border-box",
    minWidth: 100,
    bottom: 50,
    left: 16,
    overflow: "auto",
    borderRadius: "6px",
    bgcolor: "#fff",
    boxShadow: 3,
    outline: 0,
    border: "1px #dfdfdf solid",
    pt: 1,
    pb: 1,
  };

  const languajes = [
    {
      label: labels.spanish,
      value: "es",
    },
    {
      label: labels.english,
      value: "en",
    },
  ];

  return (
    <Modal
      open={show}
      onClose={() => setShow(false)}
      slotProps={{ backdrop: { style: { backgroundColor: "transparent" } } }}
    >
      <Box sx={style}>
        <div className="w-100 flex flex-dir-col align-items-center border-box">
          {languajes.map((item, index) => (
            <div
              key={`${index}${item?.value}`}
              className={`option-container ${
                selectedLanguage === item?.value ? "selected" : ""
              }`}
              onClick={() => onChangeFunction(item?.value)}
            >
              <p>{item?.label}</p>
            </div>
          ))}
        </div>
      </Box>
    </Modal>
  );
};

export default LanguageModal;
